module.exports = __webpack_public_path__ + "static/media/29ADMSPC31.d19aab93.jpg";